export default __webpack_public_path__ + "static/media/1021.d28e3429.png";